export default __webpack_public_path__ + "static/Montserrat-SemiBoldItalic-b04000635199f25a1278b86687fa70d9.ttf";